import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../utilities/cssmodules/PaymentReceipt.module.css";
import gamificationImage from "../../images/lcc_logo.png";

const PaymentReceipt = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  // Use the payment passed from MyPaymentsContent
  const payment = state?.payments;

  if (!payment) return <p>No payment selected.</p>;

  return (
    <div className={styles.component_wrapper}>
      <div className={styles.ticket_container}>
        <div className={styles.ticket_header}>
          <div className={styles.ticket_header_image}>
            <img src={gamificationImage} alt="lcc logo" className={styles.logo_1} />
          </div>
          <div className={styles.ticket_header_info}>
            <h1>Liberia Chamber of Commerce</h1>
            <p>Capitol Hill, Monrovia, Liberia</p>
            <span>
              <p>+231886800473</p> <p>info@liberiachamber.org</p>
            </span>
          </div>
          <div className={styles.ticket_header_warm_text}>
            <h2>Thank you!</h2>
            <p>Your payment was successful</p>
          </div>
        </div>

        <div className={styles.ticket_row}>
          <strong>Payment ID:</strong> {payment.id}
        </div>

        <div className={styles.ticket_row}>
          <strong>Bill Type:</strong> Subscription
        </div>

        <div className={styles.ticket_row}>
          <strong>Amount:</strong> ${payment.fees} USD
        </div>

        <div className={styles.ticket_row}>
          <strong>Paid By:</strong> {payment.businessName || "N/A"}
        </div>

        <div className={styles.ticket_row}>
          <strong>Payment Date:</strong>{" "}
          {payment.paymentDate
            ? new Date(payment.paymentDate).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            : "Not confirmed yet"}
        </div>

        <div className={styles.ticket_row}>
          <strong>Status:</strong> {payment.statusName}
        </div>

        <div className={styles.ticket_row}>
          <strong>Description:</strong> {payment.description || "Membership subscription"}
        </div>
      </div>

      <div className={styles.ticket_bottom_container}>
        Validated by Liberia Chamber of Commerce
      </div>

      <div className={styles.action_buttons_container}>
        <button className="secondary-button" onClick={() => navigate(-1)}>
          Go back
        </button>
        <button className="primary-button" onClick={() => window.print()}>
          Print receipt
        </button>
      </div>
    </div>
  );
};

export default PaymentReceipt;
